import context from 'static/script/app/ui/checkout2/context/context';
import util from 'static/script/app/ui/checkout2/context/util';
import braintreeIntegration from 'static/script/app/ui/checkout2/braintree-integration';
import coreModel from 'static/script/app/ui/checkout2/braintree-payment-core';
riot.tag2('braintree-payment', '<div> <div if="{opts.model.isBraintreeDisabled}" class="braintree-validation-error field-validation-error">Just nu går det inte att betala med kort eller PayPal.</div> <div if="{failureResolutionCode ===\'VerifyProvidedInformation\'}" class="braintree-validation-error field-validation-error">Något gick fel, kontrollera dina kortuppgifter och försök igen.</div> <div if="{failureResolutionCode ===\'ContactYourBank\'}" class="braintree-validation-error field-validation-error">Något gick fel, kontrollera dina betalningsuppgifter och inställningar. Tänk på att du kan behöva öppna ditt kort för internetköp. Det gör du vanligtvis enkelt på din internetbank.</div> <div if="{failureResolutionCode ===\'TryOtherCardType\'}" class="braintree-validation-error field-validation-error">Något gick fel, försök gärna med ett annat kort.</div> <div if="{failureResolutionCode ===\'ContactPaypal\'}" class="braintree-validation-error field-validation-error">Något gick fel, vänligen kontakta PayPal och försök igen senare.</div> <div if="{failureResolutionCode ===\'ContactOurSupport\'}" class="braintree-validation-error field-validation-error">Något gick fel, vänligen kontakta vår kundservice för ytterligare hjälp.</div> <div if="{failureResolutionCode ===\'TryAgain\'}" class="braintree-validation-error field-validation-error">Något gick fel, försök igen senare.</div> </div> <form id="braintree-integration-id" method="post" action="" show="{!opts.model.isBraintreeDisabled}"> <div class="co-radio-new {co-radio-selected:coreModel.selectedPaymentType() === \'card\'}"> <div class="header" onclick="{selectPaymentType.bind(this, \'card\')}"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div class="icon-braintree-card"></div> </div> <div class="cell-right"> &nbsp; </div> </div> <div class="body co-inner-list"> <div class="{co-inner-list-item:true, selected:isSelected, collapsed: coreModel.cards().length == 1}" each="{coreModel.cards()}"> <div if="{!isNewCard}"> <input id="{token}" type="radio" name="cardPaymentLevel" checked="{isSelected}" onclick="{selectPaymentMethod}"> <label for="{token}"> <span class="title-left"> <img class="braintree-card-logo" riot-src="{imageUrl}">{maskedCardNumber}</span> <span class="title-right"> <a if="{isDeletable()}" class="remove-link" onclick="{deletePaymentMethod}"></a> </span> </label> </div> <div if="{isNewCard && coreModel.cards().length < 4}" show="{coreModel.cards().length > 1}"> <input id="addedCard" type="radio" name="cardPaymentLevel" checked="{isSelected}" onclick="{selectPaymentMethod}"> <label for="addedCard"> <span class="title-left">Ange ett annat kort</span> </label> </div> </div> <div show="{addedCard.checked}"> <div class="card-container"> <div class="card-inputs"> <div class="card-input"> <label for="card-number">Kortnummer</label> <div class="braintree-card-input" id="card-number"></div> </div> <div class="expiration-date-input"> <label for="expiration-date">Giltigt t.o.m</label> <div class="braintree-card-input" id="expiration-date"></div> </div> <div class="cvv-input"> <label for="cvv">CVV</label> <div class="braintree-card-input" id="cvv"></div> </div> <div class="save-card"> <input id="saveCardCheckbox" name="saveCardCheckbox" type="checkbox" value="true" onclick="{saveNewCard}"> <label for="saveCardCheckbox">Spara mina uppgifter</label> </div> </div> </div> </div> </div> </div> <div if="{opts.model.isPayPayEnabled}" class="co-radio-new {co-radio-selected:coreModel.selectedPaymentType() === \'paypal\'}"> <div class="header" onclick="{selectPaymentType.bind(this, \'paypal\')}"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div class="icon icon-braintree-paypal"></div> </div> <div class="cell-right"> &nbsp; </div> </div> <div class="body co-inner-list"> <div class="{co-inner-list-item:true, selected:isSelected}" each="{coreModel.paypalAccounts()}"> <input id="{getId()}" type="radio" name="paypalPaymentLevel" checked="{isSelected}" onclick="{selectPaymentMethod}"> <label for="{getId()}"> <span class="title-left">{paypalEmail}</span> <span class="title-right"> <a if="{isDeletable()}" class="remove-link" onclick="{deletePaymentMethod}"></a> </span> </label> </div> <div class="co-inner-list-item" show="{coreModel.paypalAccounts().length < 3}"> <label> <span class="title-centered"> <a if="{coreModel.paypalAccounts().length ==0}" onclick="{initiateNewPaypalAccountFlow}" class="link">Logga in med ditt PayPal-konto</a> <a if="{coreModel.paypalAccounts().length> 0 && coreModel.paypalAccounts().length < 3}" onclick="{initiateNewPaypalAccountFlow}" class="link">Ange ett annat PayPal-konto</a> <span id="paypal-container"></span> </span> </label> </div> </div> </div> </form>', '', '', function(opts) {
        this.braintreeIntegrationId = 'braintree-integration-id';
        this.paypalContainer = 'paypal-container';

        this.context = context;
        this.util = util;
        this.braintreeIntegration = braintreeIntegration;
        this.coreModel = coreModel;

        this.context.observable.on('payment-type-selected', function (type) {
            this.selectPaymentType(type);
            this.update();
        }.bind(this));

        this.context.observable.on('payment-failed', function (paymentFailure, paymentType) {
            if (this.coreModel.isBraintreePaymentType(paymentType)) {
                this.failureResolutionCode = paymentFailure.failureResolutionCode;
                this.reloadBraintreeIntegration(this.coreModel.selectedPaymentType());
            }
        }.bind(this));

        this.context.observable.on('shipping-changed', function (item) {
            if (opts.model.isBraintreeDisabled) return;

            var paymentAmountPriorChange = this.coreModel.getPaymentAmount();
            this.coreModel.setShippingCost(item.shippingCost);

            if (paymentAmountPriorChange === this.coreModel.getPaymentAmount())
                return;

            this.reloadBraintreeIntegration(this.coreModel.selectedPaymentType());
        }.bind(this));

        this.context.observable.on('braintree-payment-prepare-for-submit', function () {
            if (!this.coreModel.prepareForSubmit()) {
                var form = document.getElementById(this.braintreeIntegrationId);
                var e = document.createEvent('Event');
                e.initEvent('submit', true, true);
                form.dispatchEvent(e);
            }

        }.bind(this));

        this.context.observable.on('braintree-verify-3d-secure', function (nonce) {
            this.verifyCardUsing3DSecure(nonce);
        }.bind(this));

        this.selectPaymentType = function (paymentType) {
            if (paymentType === this.coreModel.selectedPaymentType())
                return;

            if (this.coreModel.isBraintreePaymentType(paymentType)) {
                this.failureResolutionCode = null;
                this.reloadBraintreeIntegration(paymentType);
            } else {
                this.coreModel.selectPaymentType(paymentType);
            }
        }

        this.showProgress = function () {
            this.progressModal = this.context.modal.showModal('checkout-modal', {
                title: 'Laddar...',
                nonDismissible: true,
                showProgressIcon: true
            });
        }

        this.closeProgress = function () {
            if (this.progressModal) {
                this.progressModal.close();
                this.progressModal = null;
            }
        }

        this.reloadBraintreeIntegration = function (paymentType) {
            this.showProgress();

            this.braintreeIntegration.teardown(function () {
                this.setupBraintreeIntegration();
                this.coreModel.selectPaymentType(paymentType);
            }.bind(this));
        }

        this.setupBraintreeIntegration = function () {
            this.braintreeIntegration.setup({
                clientToken: opts.model.clientToken,
                id: this.braintreeIntegrationId,
                paypalContainer: opts.model.isPayPayEnabled ? this.paypalContainer : null,
                isInSandboxEnvironment: opts.model.isInSandboxEnvironment,
                paymentAmount: this.coreModel.getPaymentAmount(),
                onSetupReady: this.onBraintreeSetupReady.bind(this),
                onPaymentMethodReceived: this.addNewCardMethod.bind(this),
                onNewPaypalMethodCreated: this.addNewPaypalMethod.bind(this),
                onError: this.coreModel.processCardError,
                onCardValidation: this.coreModel.validateNewCard
            });
        }

        this.onBraintreeSetupReady = function (deviceData, paypalSetupFailed) {

            if (paypalSetupFailed) {
                this.util.serverLog({
                    error: 'Paypal setup failed',
                    counterName: 'braintree-payment.paypal-setup-failed'
                });
            }

            this.coreModel.setDeviceData(deviceData);
            this.closeProgress();
        }

        this.selectPaymentMethod = function (event) {
            if (this.coreModel.selectedPaymentType() === event.item.type && event.item.isSelected)
                return;

            this.parent.failureResolutionCode = null;
            this.coreModel.selectPaymentMethod(event.item);
        };

        this.saveNewCard = function () {
            this.coreModel.saveNewCardOnPayment(this.saveCardCheckbox.checked);
        }

        this.deletePaymentMethod = function (event) {
            this.coreModel.deletePaymentMethod(event.item).done(function () {
                this.parent.update();
            }.bind(this));
        }

        this.initiateNewPaypalAccountFlow = function () {
            this.braintreeIntegration.initPaypalAuthFlow();
        };

        this.addNewPaypalMethod = function (nonce, email) {
            this.coreModel.addNewPaypalAccount(nonce, email);
            this.update();
        }

        this.addNewCardMethod = function (nonce) {
            this.verifyCardUsing3DSecure(nonce);
        };

        this.verifyCardUsing3DSecure = function (nonce) {
            if (opts.model.isThreeDSecureEnabled) {
                console.log('using 3DSecure');
                var amount = this.coreModel.getPaymentAmount();
                this.braintreeIntegration.verify3DSecure(nonce, amount, this.coreModel.validate3DSecureResult.bind(
                    this), function () {
                    this.context.observable.trigger('braintree-payment-not-ready-for-submit', true);
                    this.util.serverLog({
                        counterName: 'braintree-payment.card-3dsecure.aborted'
                    });
                }.bind(this));
            } else {
                this.coreModel.prepareCard(nonce);
            }
        }

        if (!opts.model.isBraintreeDisabled) {
            this.showProgress();
            this.coreModel.init(opts.model, this.context);
            this.setupBraintreeIntegration();
        }
});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/braintree-payment.riot.html